import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArrowDiagonalDownLeft$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowDiagonalDownLeft extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a4a025951952732070ea95b666d65c9be432806c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6759f097a776a2957ea88d0b5734be5eda9e87d7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a3c358a353558271d35c27edbdd3067a60fdbbca', d: "M7.36 13.59V9.14a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .148.356.5.5 0 0 0 .356.149h6.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5H8.425l7.579-7.579a.5.5 0 0 0 0-.707l-.354-.354a.5.5 0 0 0-.707 0z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-arrow-diagonal-down-left", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-diagonal-down-left"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-diagonal-down-left":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowDiagonalDownLeft$1);
            }
            break;
    } });
}

const CosmosIconArrowDiagonalDownLeft = CosmosIconArrowDiagonalDownLeft$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowDiagonalDownLeft, defineCustomElement };
